export default "__VITE_ASSET__CPG2JgG4__"